import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";

type AsideMenuState = {
  Collapsed: boolean;
  Toggled: boolean;
};

const initialState: AsideMenuState = {
  Collapsed: false,
  Toggled: false,
};

const AsideMenuSlice = createSlice({
  name: "asideMenu",
  initialState,
  reducers: {
    setAsideCollapsed: (state, action) => {
      state.Collapsed = action.payload;
    },
    setAsideToggled: (state, action) => {
      state.Toggled = action.payload;
    },
  },
});

export const { setAsideCollapsed, setAsideToggled } = AsideMenuSlice.actions;

export const selectAsideToggled = (state: RootState) => {
  return state.asideMenu.Toggled;
};

export const selectAsideCollapsed = (state: RootState) => {
  return state.asideMenu.Collapsed;
};

export default AsideMenuSlice.reducer;
